import { CHCProductCard } from "./product-card.component.js";
import { CHCProductCardGroup } from "./product-card-group.component.js";
import { CHCProductCardHeader } from "./product-card-header.component.js";
import { CHCProductCardContent } from "./product-card-content.component.js";
import { CHCProductCardFooter } from "./product-card-footer.component.js";
import { CHCProductCardFooterCompare } from "./product-card-footer-compare.component.js";
import { CHCProductCardCTA } from "./product-card-cta.component.js";
import { CHCProductCardDrugCoverage } from "./product-card-drug-coverage.component.js";
import { CHCProductCardProvider } from "./product-card-provider.component.js";
import { CHCProductCardProviderDoctor } from "./product-card-provider-doctor.component.js";
import { CHCProductCardCopayGroup } from "./product-card-copay-group.component.js";
import { CHCProductCardCopay } from "./product-card-copay.component.js";
customElements.define("chc-product-card", CHCProductCard);
customElements.define("chc-product-card-group", CHCProductCardGroup);
customElements.define("chc-product-card-header", CHCProductCardHeader);
customElements.define("chc-product-card-content", CHCProductCardContent);
customElements.define("chc-product-card-footer", CHCProductCardFooter);
customElements.define("chc-product-card-footer-compare", CHCProductCardFooterCompare);
customElements.define("chc-product-card-cta", CHCProductCardCTA);
customElements.define("chc-product-card-drug-coverage", CHCProductCardDrugCoverage);
customElements.define("chc-product-card-provider", CHCProductCardProvider);
customElements.define("chc-product-card-provider-doctor", CHCProductCardProviderDoctor);
customElements.define("chc-product-card-copay-group", CHCProductCardCopayGroup);
customElements.define("chc-product-card-copay", CHCProductCardCopay);
export {
  CHCProductCard,
  CHCProductCardCTA,
  CHCProductCardContent,
  CHCProductCardCopay,
  CHCProductCardCopayGroup,
  CHCProductCardDrugCoverage,
  CHCProductCardFooter,
  CHCProductCardFooterCompare,
  CHCProductCardGroup,
  CHCProductCardHeader,
  CHCProductCardProvider,
  CHCProductCardProviderDoctor
};
//# sourceMappingURL=product-card.js.map
